import { openLoginOrSignupPopup } from "../../../../legacy/loginPopup";

export function checkLoggedIn(event: Event) {
    if (window.isAuthenticated() !== true) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        openLoginOrSignupPopup();
        return false;
    }
    return true;
}
